export const programs = [
  {
    "id":0,
    "Name":"Iniciantes y Fundamentos", 
    "m_Description":"Para alumnos que deseen empezar y para aquellos que deseen reforzar los conocimientos fundamentales", 
    "M_Description":"Programa creado para asegurar una base sólida en Jiu Jitsu, introduciendo técnicas en todas las posiciones, tanto en defensa como ataque.", 
    "Instructors":"Martin Paz y Francisco Cano", 
    "Duration":"1 hora", 
    "Level": "Blanco y Azul"
  },
  {
    "id":1,
    "Name":"Infantiles", 
    "m_Description":"Desarrollo y estimulación temprana en los más pequeños para prepararlos para cualquier deporte.", 
    "M_Description":"Programa creado para introducir a los mas pequeños al Jiu Jitsu a través del desarrollo  de la agilidad, flexibilidad y coordinación.", 
    "Instructors":"Katoga y Agostina", 
    "Duration":"1 hora", 
    "Level": "Iniciantes!"
  },
  /*{"id":2,"Name":"NOGI", "m_Description":"Programa creado para reforzar las bases y entendimiento conceptual del arte", "M_Description":"ASD2", "Instructors":"Martin", "Duration":"1 y 30 minutos", "Level": "Todos los niveles"},*/
  {
    "id":2,
    "Name":"Entrenamiento Profesional", 
    "m_Description":"Ejercicios específicos de competencia y sparring", 
    "M_Description":"Programa centrado en ejercicios específicos de competencia, ataque, defensa, escapes, derribos, entrenamiento físico y sparring.", 
    "Instructors":"Martin Paz", 
    "Duration":"1 y 30 minutos", 
    "Level": "Todos los niveles"
  },
  {"id":3,"Name":"Open Mat", 
  "m_Description":"Clases informales y abierta a todo el público para compartir charlas, experiencias y técnicas.", 
  "M_Description":"ASD2", "Instructors":"-", "Duration":"-", "Level": "-"},
  {
    "id":4,"Name":"Clases Privadas", 
    "m_Description":"Clases exclusivas para profundizar cualquier tema teórico/práctico del Jiu Jitsu", 
    "M_Description":"Clases exclusivas para profundizar cualquier tema teórico/práctico del Jiu Jitsu", 
    "Instructors":"Martin Paz", 
    "Duration":"1 hora", 
    "Level": "Todos los niveles"
  },
  {
    "id":5,
    "Name":"Lucha Olímpica", 
    "m_Description":"Es uno de los deportes con mayor riqueza historica. Se aprenden llaves, derribos, levantamientos, giros e inmovilizaciones.",
    "M_Description":"Deporte basado en el combate cuerpo a cuerpo. Las técnicas se basan en derribos, levantamientos, giros e inmovilizaciones. Se divide en estilos varios estilos: lucha libre, lucha grecorromana y lucha de playa. En estilo libre los combatientes están en constante movimiento, buscando el momento de poder atacar a su rival, pudiendo usar las piernas para empujar, desestabilizar o presionar. En estilo grecorromana Variante más estática, está prohibido agarrar al adversario por debajo de las caderas o apretarlo con las piernas, lo mismo que todos los empujones, presiones o levantamientos por contacto de las piernas sobre una parte del cuerpo del adversario.", 
    "Instructors":"Agustin Musante", 
    "Duration":"1 hora y 30 minutos", 
    "Level": "Todos los niveles"},
]